/**
 * Resolve instructor display name from course + Instructors directory.
 * Prefer instructorId lookup; fall back to legacy course.instructor string.
 */

export function buildInstructorByIdMap(instructors) {
  const map = {};
  (instructors || []).forEach((row) => {
    if (row.id) {
      map[row.id] = { name: row.name || '' };
    }
  });
  return map;
}

export function getDisplayInstructorName(course, instructorById) {
  if (!course) return '';
  if (course.instructorId && instructorById[course.instructorId]?.name) {
    return instructorById[course.instructorId].name;
  }
  return course.instructor || '';
}

export function buildCourseNameToInstructorMap(courses, instructorById, selectedCampus = '') {
  const map = {};

  // Pass 1: fallback map from all courses (legacy-safe)
  (courses || []).forEach((course) => {
    if (!course?.name || map[course.name]) return;
    const name = getDisplayInstructorName(course, instructorById);
    if (name) map[course.name] = name;
  });

  // Pass 2: selected campus entries override fallback for duplicate course names
  if (selectedCampus) {
    (courses || []).forEach((course) => {
      const inCampus =
        course?.name &&
        Array.isArray(course.campusCodes) &&
        course.campusCodes.includes(selectedCampus);
      if (!inCampus) return;
      const name = getDisplayInstructorName(course, instructorById);
      if (name) map[course.name] = name;
    });
  }

  return map;
}

export function getInstructorNameForCourseName(courseName, courses, instructorById) {
  const course = (courses || []).find((c) => c.name === courseName);
  if (!course) return '';
  const resolved = getDisplayInstructorName(course, instructorById);
  return resolved || 'Unknown';
}
